import { reactive, readonly } from "vue";

const state = reactive({
	isLoading: false,
	firstVisit: true,
	showIntro: false,
	showHotspots: false,
	activeLang: 'en',
  availableLangs: [],
	availableLocales: [], // for i18n
	activeContent: []
});

export default {
  state: readonly(state),
  actions: {
		toggleIntro(val) {
			console.log('toggle intro', val);
			if(!val) state.firstVisit = false;
			state.showIntro = val;
		},
		toggleLoading(val) {
			console.log('toggleLoading', val);
			state.isLoading = val
		},
		showHotspots(val) {
			console.log('showHotspots', val);
			state.showHotspots = val
		},
		setActiveLang(lang) {
			console.log('setActiveLang', lang);
			state.activeLang = lang
		},
    setAvailableLangs(items) {
      state.availableLangs = items;
			items.map(function(value) {
				state.availableLocales.push(value.lang);
			});
    },
    setActiveContent(content) {
			console.log('setActiveContent', content);
      state.activeContent = content;
    }
  }
};
